/* eslint-disable no-console */
import { useEffect } from 'react';
import { createSocket } from './socket';

function SocketInitializer() {
  const token = localStorage.getItem('token');
  useEffect(() => {
    const socket = createSocket({
      transports: ['websocket'],
      query: { token },
    });

    socket.on('connect', () => {
      console.log('Socket connected');
    });

    // Socket error
    socket.on('connect_error', err => {
      console.error('Socket connect error:', err.message);
    });

    // Generic socket error
    socket.on('error', err => {
      console.error('Socket general error:', err.message);
    });

    // Disconnection
    socket.on('disconnect', reason => {
      console.warn('Socket disconnected:', reason);
    });
    return () => {
      socket.disconnect();
    };
  }, [token]);

  return null;
}

export default SocketInitializer;
